import React from 'react';
import { ISnapIcon } from '../icons-mapper';

export const PencilAlt = (props: ISnapIcon) => {
  const { size, title, color = 'currentColor' } = props;
  return (
    <svg
      height={size}
      width={size}
      viewBox='-5 -5 35 35'
      fill='none'
      stroke={color}
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>{title}</title>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z'
        stroke={color}
        strokeWidth='1'
        strokeLinecap='round'
        strokeLinejoin='round'
      ></path>
    </svg>
  );
};
